import Swal from 'sweetalert2';

/**
 * Muestra una alerta SweetAlert2 según el status code.
 *
 * @param {object} response  Objeto de respuesta de Axios.
 * @param {string} successTitle  Título para el caso de éxito.
 * @param {string} [successText]  Texto para el caso de éxito.
 * @param {string} [errorTitle]  Título para el caso de error.
 */
export async function handleHttpAlert(
  response,
  successTitle,
  successText = '',
  errorTitle = 'Error'
) {
  // Si tenemos un código 2xx
  if (response?.status >= 200 && response.status < 300) {
    await Swal.fire({
      icon: 'success',
      title: successTitle,
      text: successText,
      timer: 1500,
      showConfirmButton: false
    });
    return true;
  } else {
    // Caso inesperado con status fuera de 2xx
    await Swal.fire({
      icon: 'error',
      title: errorTitle,
      text: `Status ${response?.status || 'desconocido'}`,
    });
    return false;
  }
}

/**
 * Muestra una alerta de error a partir de un objeto Error o AxiosError.
 *
 * @param {Error|object} error  El error capturado.
 * @param {string} [title]  Título para la alerta (por defecto 'Error').
 */
export async function showErrorAlert(error, title = 'Error') {
  const message =
    error.response?.data?.message ||
    error.message ||
    'Ocurrió un error inesperado';
  await Swal.fire({
    icon: 'error',
    title,
    text: message,
  });
}
